import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PageLayout from '../components/PageLayout';
import PageBanner from '../components/PageBanner';
import SEO from '../components/SEO';
import API from '../api';
import { useLanguage } from '../context/LanguageContext';

const BASE = process.env.REACT_APP_API_URL?.replace('/api', '') ?? 'http://localhost:5000';

export default function ClientDetail() {
  const { t } = useLanguage();
  const { slug } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/clients').then(r => {
      const c = r.data.find(c => c.slug === slug);
      setClient(c || null);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <PageLayout contactCta={false}>
      <div className="flex items-center justify-center py-40">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    </PageLayout>
  );

  if (!client) return (
    <PageLayout contactCta={false}>
      <div className="text-center py-40">
        <p className="text-gray-400 text-xl mb-4">{t('clients.notFound')}</p>
        <Link to="/clients" className="btn-primary text-sm">{t('clients.backToClients')}</Link>
      </div>
    </PageLayout>
  );

  const imgSrc = (url) => url?.startsWith('/') ? `${BASE}${url}` : url;

  return (
    <PageLayout contactCta={false}>
      <SEO title={client.name} description={client.description} />
      <PageBanner
        en="OUR CLIENTS"
        title={client.name}
        breadcrumbs={[{ label: t('common.clients'), to: '/clients' }, { label: client.name }]}
      />
      <section className="pt-6 pb-20 bg-white">
        <div className="w-[90%] max-w-4xl mx-auto">
          <Link to="/clients" className="inline-flex items-center gap-2 text-sm text-primary hover:text-accent transition-colors mb-8">
            <ArrowLeftIcon className="w-4 h-4" /> {t('clients.backToClients')}
          </Link>
          <div className="card p-8 flex flex-col sm:flex-row gap-8 items-start">
            {client.logo_url && (
              <div className="shrink-0 w-40 h-24 flex items-center justify-center border border-gray-100 p-4">
                <img src={imgSrc(client.logo_url)} alt={client.name} className="max-w-full max-h-full object-contain" />
              </div>
            )}
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-ink mb-3">{client.name}</h2>
              {client.description && <p className="text-gray-600 leading-relaxed">{client.description}</p>}
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
